import axios from "axios";
import Cookies from "js-cookie";
import { baseApiUrl } from "../env";
const baseUrl = `${baseApiUrl}/api/v1/`;

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const collectionId = Cookies.get("collectionId");
    if (collectionId) {
      // console.log(collectionId,'cIDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD')
      config.headers["Authorization"] = "";
      config.headers["collectionId"] = collectionId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


let isRefreshing = false;
let failedQueue = [];

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 302) {
       console.log(error.response)
      redirectToHome();
      
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // If a refresh is already in progress, queue the original request
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((collectionId) => {
            originalRequest.headers["collectionId"] = +collectionId;

            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;
      const token = "";
      const refToken = localStorage.getItem("refreshToken");
       return refreshToken(token, refToken)
        .then((collectionId) => {
          originalRequest.headers["collectionId"] = +collectionId;
          Cookies.set("collectionId", collectionId, { expires: 7 });
          processQueue(null, collectionId);
          return axiosInstance(originalRequest);
        })
        .catch((err) => {
          processQueue(err, null);
          if (err.response.status === 302) {
            redirectToHome();
          }
          // redirectToHome();
          return Promise.reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        });
    }
    //for access Api
    if (error.response.status === 403) {
      window.location.href = "/dashboard/403";
    }

    // if (error.response?.status === 500) {

    //   return Promise.reject(error); // Or reject with a new Error
    // }


    return Promise.reject(error);
  }
);

/**--------------------------------------------
 *               Queue for Controle Refresh
 *---------------------------------------------**/
const processQueue = (error, collectionId = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(collectionId);
    }
  });
  failedQueue = [];
};

const redirectToHome = () => {
  window.location.href = "/";
};


const refreshToken = async (token, refToken) => {
  const refreshTokenUrl = `${baseApiUrl}/api/v1/Authentication/TokenValidation`;
  const body = {
    refreshToken: refToken,
  };
  const response = await axiosInstance.post(refreshTokenUrl, body);
  return response.data?.data; // Assuming the new token is in the response
};

export default axiosInstance;
